// Do not edit! This file is maintained automatically,
// please use 'npm run index' instead
import './translate';
